module.exports = __webpack_public_path__ + "img/mail-fill.3d15a578.svg";